import { UseFormMethods } from 'react-hook-form'
import { FormInput, FormItem } from 'portal/components/RecordEditing'
import {
  ClientAddressName,
  ClientKnownAddressModalLink
} from 'portal/components/RecordsModules/Edit/ClientKnownAddressModalLink'
import styled, { css } from 'styled-components'
import { Spacer } from 'portal/lib/primitives'

export const ClientKnownAddressInput = ({
  form,
  addressName,
  knownlabel,
  knownPropertyPath,
  enteredPropertyPath,
  coordinatesPropertyPath
}: {
  form: UseFormMethods
  addressName: ClientAddressName
  knownlabel: string
  knownPropertyPath: string
  enteredPropertyPath: string
  coordinatesPropertyPath: string
}) => {
  const fieldValueText = form.getValues(knownPropertyPath)
  const fieldHasValue = form.getValues(knownPropertyPath) != null

  return (
    <>
      <FormItem label={knownlabel}>
        <KnownAddressField>
          <KnownAddressTextFiled hidden={!fieldHasValue}>
            <FormInput.Hidden name={knownPropertyPath} disabled={true} />
            <StyledFieldValue>{fieldValueText}</StyledFieldValue>
          </KnownAddressTextFiled>
          {fieldHasValue && <Spacer.Fine />}
          <ClientKnownAddressModalLink
            addressName={addressName}
            hasValue={fieldHasValue}
            onSubmit={({ entered, known, coordinates }) => {
              form.setValue(enteredPropertyPath, entered, {
                shouldValidate: true,
                shouldDirty: true
              })
              form.setValue(knownPropertyPath, known, {
                shouldValidate: true,
                shouldDirty: true
              })
              form.setValue(coordinatesPropertyPath, coordinates, {
                shouldValidate: true,
                shouldDirty: true
              })
            }}
          />
        </KnownAddressField>
      </FormItem>

      <FormItem hidden={true}>
        <FormInput.TextArea name={coordinatesPropertyPath} disabled={true} />
      </FormItem>

      <FormItem hidden={true}>
        <FormInput.TextArea name={enteredPropertyPath} disabled={true} />
      </FormItem>
    </>
  )
}

const KnownAddressField = styled.div`
  display: flex;
`
const KnownAddressTextFiled = styled.div`
  flex-grow: 2;
  ${props =>
    props.hidden &&
    css`
      display: none;
    `}
`
const StyledFieldValue = styled.div`
  font-weight: 600;
  line-height: 2rem;
`
